module.exports = __webpack_public_path__ + "img/heart-outline_gray.c3538125.svg";